var map = {
	"./avatar-afro-unselected.png": 49821,
	"./avatar-guitarbear-unselected.png": 47537,
	"./avatar-headphones-unselected.png": 61730,
	"./avatar-monocleman-unselected.png": 15712,
	"./avatar-radiohead-unselected.png": 82082,
	"./avatar-skeleton-unselected.png": 83085,
	"./avatar-trumpetman-unselected.png": 20022,
	"./avatar-violin-unselected.png": 82188,
	"./avatar-woman-unselected.png": 31489
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92142;